import { createActions } from 'redux-actions';

export const actionCreators = createActions({
  activeTab: {
    set: undefined,
  },
  currentCompany: {
    set: undefined,
    update: undefined,
    reset: undefined,
    setBusinessProfile: undefined,
    setFranchise: undefined,
    updateMerchant: undefined,
  },
  currentFranchise: {
    set: undefined,
    reset: undefined,
  },
  currentServiceProvider: {
    set: undefined,
    update: undefined,
    reset: undefined,
  },
  expandedProducts: {
    set: undefined,
    reset: undefined,
    toggle: undefined,
  },
  pendingIntegrations: {
    add: undefined,
    remove: undefined,
  },
  initialData: {
    set: undefined,
    reset: undefined,
    resetProfile: undefined,
    updateCompanies: undefined,
    markNotificationsSeen: undefined,
    toggleLoading: undefined,
  },
  sideBar: {
    setBadge: undefined,
    decrementBadge: undefined,
  },
  storefront: {
    setStore: undefined,
  },
  testRestaurants: {
    bump: undefined,
  },
  appStatus: {
    update: undefined,
  },
  platformAgent: {
    open: undefined,
    close: undefined,
    setBottomBar: undefined,
    showRestaurant: undefined,
    startChat: undefined,
    openChat: undefined,
    openChatOn: undefined,
    dropPending: undefined,
    chatStarted: undefined,
    chatUsed: undefined,
    chatCreated: undefined,
    chatEnded: undefined,
    saveChat: undefined,
    voted: undefined,
    unvoted: undefined,
    setLocation: undefined,
  },
});
